import {
  Card,
  CardHeader,
  CardBody,
  Label,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Col,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Select from "react-select";
import AdminHeader from "components/Headers/AdminHeader";

// Static training center data for prefilling
const staticTrainingCenters = [
  {
    id: 1,
    centerName: "Pune Industrial Training Center",
    addressLine1: "Plot 21, MIDC Area",
    addressLine2: "Near Infosys Circle",
    city: "Pune",
    state: "Maharashtra",
    contactPerson: "Rahul Sharma",
    contactMobile: "9876543210",
    accountStatus: "ACTIVE",
  },
  {
    id: 2,
    centerName: "Mumbai Skill Development Center",
    addressLine1: "Andheri East",
    addressLine2: "Near Metro Station",
    city: "Mumbai",
    state: "Maharashtra",
    contactPerson: "Priya Verma",
    contactMobile: "9123456789",
    accountStatus: "ACTIVE",
  },
  {
    id: 3,
    centerName: "Nagpur Technical Training Hub",
    addressLine1: "IT Park Road",
    addressLine2: "",
    city: "Nagpur",
    state: "Maharashtra",
    contactPerson: "Amit Kulkarni",
    contactMobile: "9988776655",
    accountStatus: "INACTIVE",
  },
];

const initialFields = {
  centerName: {
    value: "",
    error: "",
  },
  addressLine1: {
    value: "",
    error: "",
  },
  addressLine2: {
    value: "",
    error: "",
  },
  city: {
    value: "",
    error: "",
  },
  state: {
    value: "",
    error: "",
  },
  contactPerson: {
    value: "",
    error: "",
  },
  contactMobile: {
    value: "",
    error: "",
  },
  accountStatus: {
    value: "ACTIVE",
    error: "",
  },
};

function AddTrainingCenter() {
  const navigate = useNavigate();
  const location = useLocation();
  const mode = location.state?.mode || "add";
  const [formData, setFormData] = useState(initialFields);

  // Prefill form when in edit mode using static data
  useEffect(() => {
    if (mode === "edit") {
      // Always use first training center for static edit
      const center = staticTrainingCenters[0];

      setFormData({
        centerName: {
          value: center.centerName || "",
          error: "",
        },
        addressLine1: {
          value: center.addressLine1 || "",
          error: "",
        },
        addressLine2: {
          value: center.addressLine2 || "",
          error: "",
        },
        city: {
          value: center.city || "",
          error: "",
        },
        state: {
          value: center.state || "",
          error: "",
        },
        //   contactPerson: {
        //     value: center.contactPerson || "",
        //     error: "",
        //   },
        //   contactMobile: {
        //     value: center.contactMobile || "",
        //     error: "",
        //   },
        accountStatus: {
          value: center.accountStatus || "ACTIVE",
          error: "",
        },
      });
    }
  }, [mode]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: { value, error: "" },
    }));
  };

  const getValidationError = (name, value, allValues = {}) => {
    const isEmpty =
      value === "" ||
      value === null ||
      (Array.isArray(value) && value.length === 0);

    switch (name) {
      // Basic Information
      case "centerName":
        return value ? "" : "Please enter center name";

      case "addressLine1":
        return value ? "" : "Please enter address line 1";

      case "city":
        return value ? "" : "Please enter city";

      case "state":
        return value ? "" : "Please enter state";

      //   case "contactPerson":
      //     return value ? "" : "Please enter contact person name";

      //   case "contactMobile":
      //     if (!value) return "Please enter mobile number";
      //     if (!REGEX.PHONE_NO_REGEX.test(value))
      //       return "Mobile number must contain 10 digits only";
      //     return "";

      default:
        return "";
    }
  };

  const handleOnBlur = (name, value) => {
    const trimmed = typeof value === "string" ? value.trim() : value;
    const error = getValidationError(name, trimmed);
    setFormData((prev) => ({
      ...prev,
      [name]: {
        ...prev[name],
        value: trimmed,
        error,
      },
    }));
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: {
        ...prev[field],
        value,
        error: "",
        isChanged: true,
      },
    }));
  };

  return (
    <>
      <AdminHeader parentName="Instructors" />
      <Container className="mt--6" fluid>
        <Card className="mb-4">
          <CardHeader className="d-flex align-items-center ">
            <i
              className="fa fa-chevron-left mr-2 cursor"
              onClick={() => navigate("/admin/training-center")}
            />
            <h3 className="mb-0">
              {mode === "edit" ? "Edit Training Center" : "Add Training Center"}
            </h3>
          </CardHeader>

          <CardBody>
            {/* Training Center Information */}
            <Row>
              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">
                    Center Name <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="centerName"
                    value={formData.centerName.value}
                    placeholder="Enter center name"
                    onChange={(e) =>
                      handleInputChange("centerName", e.target.value)
                    }
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={formData.centerName.error ? "is-invalid" : ""}
                  />
                  {formData.centerName.error && (
                    <small className="invalid-feedback d-block">
                      {formData.centerName.error}
                    </small>
                  )}
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">
                    Address Line 1 <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="addressLine1"
                    value={formData.addressLine1.value}
                    placeholder="Enter address line 1"
                    onChange={(e) =>
                      handleInputChange("addressLine1", e.target.value)
                    }
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={formData.addressLine1.error ? "is-invalid" : ""}
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">Address Line 2</Label>
                  <Input
                    type="text"
                    name="addressLine2"
                    value={formData.addressLine2.value}
                    placeholder="Enter address line 2"
                    onChange={(e) =>
                      handleInputChange("addressLine2", e.target.value)
                    }
                  />
                </FormGroup>
              </Col>
            </Row>

            <Row>
              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">
                    City <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="city"
                    value={formData.city.value}
                    placeholder="Enter city"
                    onChange={(e) => handleInputChange("city", e.target.value)}
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={formData.city.error ? "is-invalid" : ""}
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">
                    State <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="state"
                    value={formData.state.value}
                    placeholder="Enter state"
                    onChange={(e) => handleInputChange("state", e.target.value)}
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={formData.state.error ? "is-invalid" : ""}
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">
                    Status <span className="text-danger">*</span>
                  </Label>

                  <div className="d-flex mt-2">
                    <FormGroup check className="mr-4">
                      <Label check>
                        <Input
                          type="radio"
                          name="accountStatus"
                          checked={formData.accountStatus.value === "ACTIVE"}
                          onChange={() =>
                            handleChange("accountStatus", "ACTIVE")
                          }
                        />
                        Active
                      </Label>
                    </FormGroup>

                    <FormGroup check>
                      <Label check>
                        <Input
                          type="radio"
                          name="accountStatus"
                          checked={formData.accountStatus.value === "INACTIVE"}
                          onChange={() =>
                            handleChange("accountStatus", "INACTIVE")
                          }
                        />
                        Inactive
                      </Label>
                    </FormGroup>
                  </div>
                </FormGroup>
              </Col>
            </Row>

            <Row>
              {/* <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">
                    Contact Person <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="text"
                    name="contactPerson"
                    value={formData.contactPerson.value}
                    placeholder="Enter contact person name"
                    onChange={(e) =>
                      handleInputChange("contactPerson", e.target.value)
                    }
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={formData.contactPerson.error ? "is-invalid" : ""}
                  />
                </FormGroup>
              </Col>

              <Col md="4">
                <FormGroup>
                  <Label className="form-control-label">
                    Contact Mobile No <span className="text-danger">*</span>
                  </Label>
                  <Input
                    type="tel"
                    name="contactMobile"
                    value={formData.contactMobile.value}
                    placeholder="Enter mobile number"
                    maxLength={10}
                    onChange={(e) =>
                      handleInputChange("contactMobile", e.target.value)
                    }
                    onBlur={(e) => handleOnBlur(e.target.name, e.target.value)}
                    className={formData.contactMobile.error ? "is-invalid" : ""}
                  />
                </FormGroup>
              </Col> */}
            </Row>

            {/* Action Buttons */}
            <Row className="mt-4">
              <Col className="text-right">
                <button
                  className="btn btn-secondary mr-2"
                  onClick={() => navigate("/admin/training-center")}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-deep-blue"
                  color="primary"
                  type="submit"
                  onClick={() => navigate("/admin/training-center")}
                >
                  Save
                </button>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </>
  );
}

export default AddTrainingCenter;
